<template>
  <v-container
    class="pa-0 mt-1 d-flex align-start"
    :style="{ maxWidth: maxWidth + 'px' }"
  >
    <v-card
      class="rounded-lg"
      width="100%"
      :height="$vuetify.breakpoint.height - 100 + 'px'"
    >
      <v-card-title
        class="primary white--text px-1 pb-3 pt-1 d-flex justify-space-between"
      >
        <div>
          <v-btn icon dark to="/session">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span class="ml-2">{{ session_data.title }}</span>
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" dark>
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ session_data.description }}</span>
          </v-tooltip>
        </div>

        <v-btn icon dark to="/profile">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="white rounded-lg card-relative">
        <v-row>
          <v-col cols="12" md="8">
            <div style="position: absolute;top: 45%;left: 30%;z-index:1">
              <v-btn  v-if="show_playingbutton" color="success" fab  x-large @click="playVideo">
                <v-icon>mdi-play-circle-outline</v-icon>
              </v-btn>
            </div>
            <video width="100%" height="100%" autoplay v-if="!session_data.is_live_meeting"
            :src="session_data.meeting_id_url+'#t='+startTime"
            ref="player"
            class="disable_click"
            >
              Your browser does not support the video tag.
            </video>
            <!-- <iframe
              width="100%"
              height="100%"
              :src="getYoutubeUrl(session_data.meeting_id_url)"
              class="rounded-lg disable_click"
              v-if="!session_data.is_live_meeting"
              ref="player"
              allow="autoplay"
            ></iframe> -->
            <iframe
              width="100%"
              height="100%"
              :src="base_url + session_data.meeting_id_url"
              class="rounded-lg"
              allow="camera; microphone"
              allowfullscreen
              v-else
            ></iframe>
            <span v-if="session_data.is_live_meeting" class="text-body-2 primary--text"> <v-icon>mdi-information-outline</v-icon> Please click the Full Screen icon to view Panelist's Camera with Shared Screen</span>
          </v-col>
          <v-col cols="12" md="4">
            <v-card flat class="mx-auto">
              <v-card-title class="pa-0">
                <v-btn
                  block
                  color="primary"
                  class="text-capitalize"
                  to="/info-desk"
                >
                  Help
                  <span class="mdi mdi-help-circle-outline text-h6"></span>
                </v-btn>
              </v-card-title>
              <v-card-text
                class="chat-screen d-flex flex-column-reverse grey lighten-4 pa-0"
              >
                <v-card
                  v-for="message in session_message"
                  :key="message.message_id"
                  flat
                  class="grey lighten-4"
                >
                  <v-list-item
                    :key="message.message_id"
                    v-if="message.attendee_id != myself.attendee_id"
                    class=""
                  >
                    <v-list-item-avatar
                      class="align-self-start mr-2 elevation-1"
                    >
                      <v-avatar size="40">
                        <v-img :src="message.attendee_data.profile_pic"></v-img>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content class="received-message">
                      <v-card color="success" class="flex-none">
                        <v-card-text
                          class="white--text pa-2 d-flex flex-column"
                        >
                          <span class="text-caption"
                            >{{ message.attendee_data.first_name }}
                            <v-icon dark title="Speaker / Panelist" size="15" v-if="!message.add_by_attendee"
                              >mdi-shield-star-outline</v-icon
                            >
                          </span>
                          <span class="align-self-start text-subtitle-1">{{
                            message.message
                          }}</span>
                          <span
                            class="text-caption font-italic align-self-end"
                            >{{ getTime(message.created_at) }}</span
                          >
                        </v-card-text>
                      </v-card>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-else :key="message.message_id">
                    <v-list-item-content class="sent-message justify-end">
                      <v-card color="primary" class="flex-none">
                        <v-card-text
                          class="white--text pa-2 d-flex flex-column"
                        >
                          <span class="text-subtitle-1 chat-message">{{
                            message.message
                          }}</span>
                          <span class="text-caption font-italic align-self-start">
                            {{ getTime(message.created_at) }}
                          </span>
                          <v-icon dark title="Speaker / Panelist" size="10" v-if="!message.add_by_attendee"></v-icon>
                        </v-card-text>
                      </v-card>
                    </v-list-item-content>
                    <v-list-item-avatar
                      class="align-self-start ml-2 elevation-1"
                    >
                      <v-img :src="message.attendee_data.profile_pic"></v-img>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-card>
              </v-card-text>
              <v-card-actions class="pa-0">
                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      outlined
                      placeholder="Type your message"
                      rows="2"
                      v-model="new_message"
                      @keydown.enter.exact.prevent
                      @keyup.enter.exact="sendMessage()"
                      @keydown.enter.shift.exact="newlineMessage"
                      :loading="send_loading"
                      hide-details=""
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" class="d-flex">
                    <i :class="{ 'red--text': messageLength > 400 }"
                      >Charcter left : {{ 400 - messageLength }}</i
                    >
                    <v-spacer></v-spacer>
                    <b>Participants joined : {{ activeUsers }}</b>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "@/helper/axios";
import { mapState, mapActions } from "vuex";
export default {
  name: "SessionList",
  components: {},
  data() {
    return {
      session_data: [],
      session_message: [],
      new_message: "",
      send_loading: false,
      socket_messages: [],
      activeUsers: 0,
      subscription: null,
      show_playingbutton : false,
      startTime : 0,
      time: this.moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapState("utils", ["maxWidth"]),
    base_url() {
      return (
        axios.defaults.baseURL +
        "zoom-meeting?token=" +
        this.myself.attendee_token +
        "&meetingNumber="
      );
    },
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    },
    newMessageWithoutSpace() {
      return this.new_message.trim();
    },
    messageLength() {
      return this.newMessageWithoutSpace.length;
    },
    reverse_messages() {
      let messages = this.session_message;
      let msgArray = [];
      for (let i = messages.length; i--; ) {
        msgArray.push(messages[i]);
      }
      return msgArray;
    },
  },
  methods: {
    ...mapActions("active_session", ["setSession", "removeSession"]),
    playVideo(){
      console.log('asddsd')
      this.show_playingbutton = false
      this.$refs['player'].play()
    },
    getYoutubeUrl(video_id) {
      return (
        "https://www.youtube.com/embed/" +
        video_id +
        "?autoplay=1&controls=0&disablekb=0&loop=1&playlist=" +
        video_id
      );
    },
    getTime(time) {
      let msg_date = this.moment(time);
      let today = this.moment(new Date());
      if (msg_date.isSame(today, "day")) {
        return this.moment(time).format("hh:mm A");
      } else {
        return msg_date.format("DD, MMM hh:mm A");
      }
    },
    newlineMessage() {
      this.new_message = `${this.new_message}`;
    },
    setSocketMessage(data) {
      this.session_message.unshift(data);
    },
    setActiveUsers(data) {
      this.activeUsers = data;
    },
    sendMessage() {
      if (this.newMessageWithoutSpace.length && this.messageLength <= 400) {
        this.send_loading = true;
        let data = {
          message: this.newMessageWithoutSpace,
          session_id: this.$route.params.id,
        };
        axios
          .post("/session/add_message", data)
          .then(() => {
            this.new_message = "";
            // this.session_message.unshift(data.data.data)
          })
          .then(() => {
            this.send_loading = false;
          });
      }
    },
    getSessionDetails() {
      axios
        .get("/session/details", {
          params: {
            session_id: this.$route.params.id,
            time : new Date().toString()
          },
        })
        .then((data) => {
          this.session_data = data.data.data;
          if (this.isUpcoming(this.session_data)) {
            this.$router.push({ path: "/session" });
          }
           let  startTime = this.moment(this.session_data.start_time);
           let currentTime = this.moment();
           this.startTime = currentTime.diff(startTime, "seconds")
        });
    },
    getSessionMessages() {
      axios
        .get("/session/message_list", {
          params: {
            session_id: this.$route.params.id,
          },
        })
        .then((data) => {
          this.session_message = data.data.data;
        });
    },
    isCompleted(session){
      let endTime = this.moment(session.end_time);
      let currentTime = this.moment();
      return endTime.diff(currentTime, 'seconds') < 0
    },
    isUpcoming(session) {
      let startTime = this.moment(session.start_time);
      let endTime = this.moment(session.end_time);
      let currentTime = this.moment();
      return !currentTime.isBetween(startTime, endTime) && this.isCompleted(session)
    },
  },
  created: function () {
    this.removeSession();
  },
  mounted: function () {
    this.getSessionDetails();
    this.getSessionMessages();
    this.subscription = this.$ws.socket.getSubscription(
      `session:${this.$route.params.id}`
    );
    let is_autoplay = localStorage.getItem('autoplay')
    if(is_autoplay == 'false'){
      this.show_playingbutton = true
    }
    if (!this.subscription) {
      this.subscription = this.$ws.subscribe(
        `session:${this.$route.params.id}`
      );
      this.$ws.$on(
        `session:${this.$route.params.id}|new_message`,
        this.setSocketMessage
      );
      this.$ws.$on(
        `session:${this.$route.params.id}|active_users`,
        this.setActiveUsers
      );
    } else {
      this.$ws.$on(
        `session:${this.$route.params.id}|new_message`,
        this.setSocketMessage
      );
      this.$ws.$on(
        `session:${this.$route.params.id}|active_users`,
        this.setActiveUsers
      );
    }
  },
  updated: function () {
    this.$nextTick(function () {});
  },
  beforeDestroy() {
    // //Remove listeners when component destroy
    this.$ws.$off(`session:${this.$route.params.id}`);
    this.setSession(this.session_data);
  },
  beforeRouteEnter  (to,from,next) {
    to;
    console.clear()
    console.log(from)
    if(from.name){
      localStorage.setItem('autoplay',true)
    } else {
      localStorage.setItem('autoplay',false)
    }
    next((vm) => {
     vm.from = from;
    });
  }
};
</script>
<style scoped>
.disable_click{
  pointer-events:none;
}
.chat-message {
  display: unset !important;
  white-space: break-spaces;
}
.chat-screen {
  overflow-y: auto;
  height: 400px;
  max-height: 400px;
}
.flex-none {
  flex: unset;
}
.received-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 54px;
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #4caf50 transparent transparent transparent;
}
.sent-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 54px;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #294c9e transparent transparent transparent;
}
.card-relative {
  position: relative;
  top: -10px;
}
textarea {
  line-height: 1.2rem !important;
}
</style>
